import React from "react";
import './App.css';
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container"> 

      <Weather defaultCity="Rome"/>
      <footer>This project was created by Marta Freri and is open-sourced on <a href="https://github.com/martafreri2018/react-weather-app" target="_blank"> Github </a>
       </footer>
    </div>
    </div>
  );
}


